import { AgileEvaluationIcon } from '@hcs/design-system';
import { AppSlugs } from '@hcs/types';
import { AppConfig } from '@hcs/types';

export const APP_CONFIG_AGILE_OPS_COMMAND: AppConfig = {
  name: 'AgileOps Command Center',
  applicationKey: 'internal-agile-ops',
  type: 'internal',
  appSlugForEngagement: AppSlugs.AgileOpsCommandCenter,
  Icon: AgileEvaluationIcon,
  rootPath: '/agile-ops',
  descriptionLong: 'Quality Control Tools for the HC Agile Ops Team',
  descriptionShort: 'Quality Control Tools for the HC Agile Ops Team',
};
export const VIEW_PATHS_AGILE_OPS_COMMAND = {
  ALL_ADDRESSES: 'all-addresses',
  REVIEW_QUEUE: 'review-queue',
  ORDER_ITEM: 'order-item/:orderItemId',
} as const;
